const lui_dropdown = function (selector) {
  selector.addEventListener("click", (e) => lui_dropdown_process(selector, e))
  selector.addEventListener("keydown", (e) => {
    if (e.key === ' ') {
      e.stopPropagation();
      e.preventDefault();
      lui_dropdown_process(selector, e)

    }
  })
};

function lui_dropdown_process(selector,e) {
  e.preventDefault();
  importScript(cdnjs.jquery, () => {
    selector = $(selector);
    let body = selector.find("[data-ref-body]");

    body.stop();

    if (selector.hasClass("state--active")) {
      body.slideUp();
      selector.removeClass("state--active");
      selector.attr("aria-expanded", "false");
    } else {
      body.slideDown();
      selector.addClass("state--active");
      selector.attr("aria-expanded", "true");
    }
  })
}